import AccountingDocumentState from "../shared/documentInfrastructure/AccountingDocumentState.js";

/**
 * Hold and manage the state for the forecast archive document.
 */
export default class ForecastTemplateArchiveDocumentState extends AccountingDocumentState {
	getForecastTemplates() {
		return this._forecastTemplates;
	}

	async fetchForecastTemplates() {
		this._forecastTemplates = await this._service.fetchForecastTemplates();
	}

	deleteForecastTemplate(...rest) {
		return this._service.deleteForecastTemplate(...rest);
	}

	updateForecastTemplateName(...rest) {
		return this._service.updateForecastTemplateName(...rest);
	}

	setMainForecastTemplate(...rest) {
		return this._service.setMainForecastTemplate(...rest);
	}

	hasDefaultForecastConfiguration() {
		return this._service.hasDefaultForecastConfiguration();
	}

	makeForecastTemplate({ model }) {
		return this._service.makeForecastTemplate({ model });
	}

	copyForecastTemplate({ forecastTemplate, model }) {
		return this._service.copyForecastTemplate({ forecastTemplate, model });
	}

	_setupInitialData({ forecastTemplates }) {
		this._forecastTemplates = forecastTemplates;
	}
}
